import * as React from 'react';
import {FilterIcon} from './components/FiltersDropdown';
import {invalidateCurrent} from '../../_shared/GWTBridge/invoke/netForm';

export async function renderFilterIcon(
    root,
    props: {tableName: string; field: number; fieldName: string; title: string; session: string}
) {
    root.render(
        <FilterIcon
            tableName={props.tableName}
            field={props.field.toString()}
            fieldName={props.fieldName}
            title={props.title}
            session={props.session}
            setCurrentForm={() => invalidateCurrent(props.session)}
        />
    );
}
